import React from 'react';

const ArticleDetails = ({ article }) => {
  const defaultArticle = {
    title: "Improved OS with Adjuvant Immunotherapy in Stage III Melanoma",
    findings: [
      "43% reduction in recurrence risk",
      "Benefit extends to BRAF wild-type",
      "Grade 3-4 adverse events in 14%"
    ],
    relevance: [
      "5 current patients eligible",
      "Consider for patients with upcoming resections"
    ]
  };
  
  const articleData = article || defaultArticle;
  
  return (
    <div className="bg-gray-200 p-4 h-full">
      <h2 className="text-lg font-medium text-gray-700 mb-2">Selected Article:</h2>
      
      <h3 className="text-xl font-medium text-gray-800 mb-4">"{articleData.title}"</h3>
      
      <div className="mb-4">
        <h4 className="font-medium text-gray-700 mb-1">Key Findings:</h4>
        <ul className="space-y-1 mb-4">
          {articleData.findings.map((finding, index) => (
            <li key={index} className="text-gray-700 flex items-start">
              <span className="mr-1">•</span> {finding}
            </li>
          ))}
        </ul>
      </div>
      
      <div className="mb-4">
        <h4 className="font-medium text-gray-700 mb-1">Relevance to Practice:</h4>
        <ul className="space-y-1 mb-4">
          {articleData.relevance.map((item, index) => (
            <li key={index} className="text-gray-700 flex items-start">
              <span className="mr-1">•</span> {item}
            </li>
          ))}
        </ul>
      </div>
      
      <div className="space-y-2">
        <button className="w-full py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
          View Full Article
        </button>
        <button className="w-full py-2 bg-green-500 text-white rounded hover:bg-green-600">
          Save to Library
        </button>
        <button className="w-full py-2 bg-purple-500 text-white rounded hover:bg-purple-600">
          Add to Knowledge
        </button>
      </div>
    </div>
  );
};

export default ArticleDetails;